// ─────────────────────────────────────────────
//  PerPerson.jsx
//  Desglose por persona
// ─────────────────────────────────────────────

import React from 'react';
import styles from './PerPerson.module.css';
import { formatAmount } from '../../utils/format';

export default function PerPerson({
	total,
	amount,
	tipAmount,
	perAmount,
	perTip,
	people,
	hasAmount,
	tipPct,
	useIntegerAmounts = false,
	roundPerPerson = false,
	onRoundPerPersonChange,
}) {
	const perTotal = perAmount + perTip;
	const displayAmount = (value) =>
		formatAmount(value, { forceInteger: useIntegerAmounts });

	// const badgeText = people === 1 ? '÷ 1 persona' : `÷ ${people} personas`;
	const headerLabel = people === 1 ? 'Total a pagar' : 'Cada persona paga';

	

	return (
		<>
			{hasAmount && people > 1 ? (
				<>
					<section className={styles.card} aria-label="Monto por persona">

						<div className={styles.totalWrap}>
							<p className={styles.totalLabel}>{headerLabel}</p>
							<p className={styles.totalValue} aria-live="polite">
								<span className={styles.curr}>$&nbsp;&nbsp;</span>
								{displayAmount(perTotal)}
							</p>
						</div>


						<div className={styles.breakdown}>
							
							<div className={styles.miniCard}>
								<p className={styles.miniLabel}>
									{people === 1 ? 'Consumo' : 'Consumo'}
								</p>
								<p className={styles.miniValue}><b>{displayAmount(perAmount)}</b></p>
							</div>

							<div className={`${styles.miniCard} ${styles.miniTip}`}>
								<p className={styles.miniLabel}>
									{people === 1 ? 'Propina' : 'Propina'}
								</p>
								<p className={`${styles.miniValue} ${styles.tipColor}`}><b>
									{displayAmount(perTip)}
								</b></p>
							</div>
							

							
							{/* <div className={styles.miniCard2}>
								<p className={styles.miniLabel2}>
									{people === 1 ? 'Consumo' : 'Consumo total'}
								</p>
								<p className={styles.miniValue}>{displayAmount(amount)}</p>
							</div> */}
							
							{/* <div className={styles.miniCard2}>
								<p className={styles.miniLabel2}>
									{people === 1 ? 'Propina' : 'Propina total'} <span>({tipPct} %)</span>
								</p>
								<p className={`${styles.miniValue} ${styles.tipColor}`}>
									{displayAmount(tipAmount)}
								</p>
							</div> */}

							{/* <div className={styles.miniCard2}>
								<p className={styles.miniLabel2}>
									{people === 1 ? 'Consumo' : 'Total a pagar'}
								</p>
								<p className={`${styles.miniValue} ${styles.totalColor}`}>{displayAmount(total)}</p>
							</div> */}

						</div>
					</section>

					{/* <div className={styles.switchRow}>
						<ToggleSwitch
							label="Redondear x persona"
							checked={roundPerPerson}
							onChange={onRoundPerPersonChange}
							ariaLabel="Redondear total por persona hacia arriba"
						/>
					</div> */}

					{/* <div className={styles.spaceBottom}></div> */}
				</>
			) : (
				<>
				{/* <p className={styles.empty}>Ingresa un monto para comenzar</p> */}
				</>
			)}
		</>
	);
}